import React from 'react';
import { AlertCircle, ArrowRight } from 'lucide-react';
import { signs } from '../mock';

export default function Signs({ onSchedule }) {
  return (
    <section className="section" style={{ backgroundColor: 'var(--forest)' }}>
      <div className="container-x">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div className="reveal">
            <p className="eyebrow mb-2" style={{ color: '#B8D89E' }}>Recognize the Need</p>
            <h2 className="text-white" style={{ color: '#fff', fontSize: 'clamp(2rem, 4vw, 3rem)' }}>
              Signs it may be time for in-home care
            </h2>
            <p className="mt-5 text-white/75">
              We understand the quiet worry of having an aging loved one living alone. If any of
              these feel familiar, a conversation might bring the peace of mind you&rsquo;ve been
              longing for &mdash; no pressure, no obligation.
            </p>
            <button className="btn-sage mt-8" onClick={onSchedule}>
              Talk With a Care Specialist <ArrowRight size={18} />
            </button>
          </div>

          <div className="reveal grid sm:grid-cols-2 gap-4">
            {signs.map((s) => (
              <div
                key={s}
                className="flex items-start gap-3 p-5 rounded-2xl"
                style={{ backgroundColor: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.12)' }}
              >
                <AlertCircle size={20} style={{ color: 'var(--sage)' }} className="mt-0.5 shrink-0" />
                <span className="text-white/90 text-[15px]">{s}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
